import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';
import RadioButton from './RadioButton/RadioButton';
import { classes } from './RadioGroup.st.css';
import { dataHooks } from './constants';
/**
 * component for easy radio group creation.
 *
 * similar to HTML `<input type="radio"/>` except you don't need to handle `name` or click handlers
 */

var RadioGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RadioGroup, _React$PureComponent);

  var _super = _createSuper(RadioGroup);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _super.call(this, props);
    _this.name = uniqueId('RadioGroup_');
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          disabledRadios = _this$props.disabledRadios,
          value = _this$props.value,
          vAlign = _this$props.vAlign,
          display = _this$props.display,
          spacing = _this$props.spacing,
          lineHeight = _this$props.lineHeight,
          selectionArea = _this$props.selectionArea;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: classNames(classes[display], (_classNames = {}, _defineProperty(_classNames, classes.selectionAreaAlways, selectionArea === 'always'), _defineProperty(_classNames, classes.selectionAreaHover, selectionArea === 'hover'), _defineProperty(_classNames, classes.vertical, display === 'vertical'), _classNames)),
        "data-display": display
      }, React.Children.map(this.props.children, function (radio, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames(classes.optionWrapper),
          "data-hook": dataHooks.RadioGroupRadioContainer,
          style: display === 'vertical' && index > 0 ? {
            marginTop: spacing
          } : {}
        }, /*#__PURE__*/React.createElement(RadioGroup.Radio, {
          dataHook: radio.props.dataHook,
          value: radio.props.value,
          name: _this2.name,
          onChange: onChange,
          vAlign: vAlign,
          disabled: disabled || disabledRadios.indexOf(radio.props.value) !== -1,
          checked: radio.props.value === value,
          selectionArea: selectionArea,
          icon: radio.props.icon,
          lineHeight: lineHeight,
          content: radio.props.content
        }, radio.props.children));
      }));
    }
  }]);

  return RadioGroup;
}(React.PureComponent);

RadioGroup.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Callback function when user selects a different value */
  onChange: PropTypes.func,

  /** Selected radio button value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** the values of the disabled radio buttons */
  disabledRadios: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** Positioning of the radio bottom compared to the label */
  vAlign: PropTypes.oneOf(['center', 'top']),

  /** Make the entire control disabled */
  disabled: PropTypes.bool,

  /** Display direction of the radios */
  display: PropTypes.oneOf(['vertical', 'horizontal']),

  /** Selection area emphasises the clickable area, none means no emphasis, hover is when the mouse is on the component, and always will show constantly */
  selectionArea: PropTypes.oneOf(['none', 'hover', 'always']),
  children: PropTypes.arrayOf(function (propValue, key) {
    if (propValue[key].type.displayName !== RadioButton.displayName) {
      return new Error("RadioGroup: Invalid Prop children was given. Validation failed on child number ".concat(key));
    }
  }),

  /** Vertical spacing between radio buttons */
  spacing: PropTypes.string,

  /** Text line height */
  lineHeight: PropTypes.string
};
RadioGroup.defaultProps = {
  disabledRadios: [],
  onChange: function onChange() {},
  value: '',
  vAlign: 'center',
  display: 'vertical',
  lineHeight: '24px',
  selectionArea: 'none'
};
RadioGroup.Radio = RadioButton;
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;